(() => {
  const section = document.querySelector('product-info[data-section]');
  if (!section) return;

  const variantsNode = document.getElementById(`HgProductVariants-${section.dataset.section}`);
  let variants = [];
  try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) { /* Keep optional enhancements hidden. */ }
  const variantById = new Map(variants.map((variant) => [String(variant.id), variant]));
  const seedCount = (title) => {
    const match = String(title || '').match(/\b(\d[\d,]*)\s*seeds?\b/i);
    return match ? Number(match[1].replaceAll(',', '')) : null;
  };
  const dollars = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  const addBusinessDays = (start, count) => {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    for (let added = 0; added < count;) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added++;
    }
    return date;
  };
  const shortDate = (date) => date.toLocaleDateString(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' });
  const delivery = section.querySelector('[data-hg-delivery-estimate]');
  if (delivery) {
    const today = new Date();
    const dates = delivery.querySelector('[data-hg-delivery-dates]');
    dates.textContent = delivery.dataset.template.replace('__FIRST__', shortDate(addBusinessDays(today, 10))).replace('__LAST__', shortDate(addBusinessDays(today, 15)));
  }

  const currentVariant = () => {
    const id = section.querySelector('product-form input[name="id"]')?.value;
    return variantById.get(String(id)) || variantById.get(new URLSearchParams(location.search).get('variant')) || variants[0];
  };
  const normalizePills = () => {
    section.querySelectorAll('.product-form__input--pill label').forEach((label) => {
      if (label.dataset.hgSeedLabel) return;
      // Edit only the label's own text nodes; the visually-hidden "sold out" span must stay a separate element.
      const textNodes = [...label.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      if (!textNodes.some((node) => seedCount(node.textContent))) return;
      textNodes.forEach((node) => {
        node.textContent = node.textContent.replace(/\b(\d[\d,]*)\s*seeds?\b/i, (_, count) => `${count} seeds`);
      });
      label.dataset.hgSeedLabel = 'true';
    });
  };
  const updateVariant = () => {
    const variant = currentVariant();
    if (!variant) return;
    normalizePills();
    const unit = section.querySelector('[data-hg-unit-price]');
    const count = seedCount(variant.title);
    if (unit) {
      const isUsd = !window.Shopify?.currency?.active || window.Shopify.currency.active === 'USD';
      unit.hidden = !count || !isUsd;
      if (!unit.hidden) {
        const perSeed = variant.price / 100 / count;
        const unitText = perSeed < 0.01
          ? unit.dataset.hundredTemplate.replace('__AMOUNT__', dollars(perSeed * 100))
          : unit.dataset.template.replace('__AMOUNT__', dollars(perSeed));
        if (unit.textContent !== unitText) unit.textContent = unitText;
      }
    }
    if (delivery) delivery.hidden = !variant.requires_shipping;
    const stock = section.querySelector('[data-hg-stock]');
    if (stock) {
      stock.dataset.available = String(variant.available);
      const label = stock.querySelector('strong');
      if (label) label.textContent = variant.available ? stock.dataset.inStock : stock.dataset.soldOut;
    }
    const notify = section.querySelector('[data-hg-notify-me]');
    if (notify) {
      notify.hidden = variant.available && !notify.querySelector('[data-hg-notify-success]');
      const body = notify.querySelector('[data-hg-notify-body]');
      if (body) body.value = `Back-in-stock request: ${section.querySelector('.product__title h1')?.textContent.trim() || ''} / ${variant.title}`;
    }
  };
  let updateQueued = false;
  const queueUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    requestAnimationFrame(() => { updateQueued = false; updateVariant(); });
  };
  section.addEventListener('change', queueUpdate);
  new MutationObserver(queueUpdate).observe(section, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked'] });
  updateVariant();

  const sticky = section.querySelector('.hg-sticky-atc');
  const mainButton = section.querySelector(`#ProductSubmitButton-${section.dataset.section}`);
  const mainQuantity = section.querySelector(`#Quantity-${section.dataset.section}`);
  if (sticky && mainButton && mainQuantity) {
    const stickyButton = sticky.querySelector('.hg-sticky-atc__button');
    const stickyQuantity = sticky.querySelector('[data-hg-sticky-quantity]');
    const syncSticky = () => {
      stickyButton.disabled = mainButton.disabled;
      const mainLabel = mainButton.querySelector('span');
      if (mainLabel?.textContent.trim()) stickyButton.textContent = mainLabel.textContent.trim();
      stickyQuantity.textContent = mainQuantity.value || '1';
      const priceRoot = section.querySelector(`#price-${section.dataset.section} .price`);
      const price = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      if (price?.textContent.trim()) sticky.querySelector('.hg-sticky-atc__summary strong').textContent = price.textContent.trim();
    };
    stickyButton.addEventListener('click', () => { if (!mainButton.disabled) mainButton.click(); });
    sticky.querySelector('[data-hg-sticky-minus]').addEventListener('click', () => section.querySelector(`#Quantity-Form-${section.dataset.section} button[name="minus"]`)?.click());
    sticky.querySelector('[data-hg-sticky-plus]').addEventListener('click', () => section.querySelector(`#Quantity-Form-${section.dataset.section} button[name="plus"]`)?.click());
    mainQuantity.addEventListener('change', syncSticky);
    mainQuantity.addEventListener('input', syncSticky);
    new MutationObserver(syncSticky).observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
    const priceBox = section.querySelector(`#price-${section.dataset.section}`);
    if (priceBox) new MutationObserver(syncSticky).observe(priceBox, { childList: true, subtree: true });
    sticky.classList.remove('is-active');
    sticky.hidden = true;
    let stickyObserver;
    const stickyHeaderBottom = () => Math.max(0, ...[...document.querySelectorAll('.section-header, .utility-bar')]
      .map((element) => element.getBoundingClientRect().bottom));
    const refreshSticky = () => {
      const headerBottom = stickyHeaderBottom();
      sticky.style.setProperty('--header-height', `${headerBottom}px`);
      const showSticky = mainButton.getBoundingClientRect().bottom <= headerBottom;
      sticky.hidden = !showSticky;
      sticky.classList.toggle('is-active', showSticky);
    };
    const observeMainButton = () => {
      stickyObserver?.disconnect();
      const headerBottom = stickyHeaderBottom();
      stickyObserver = new IntersectionObserver(refreshSticky, { rootMargin: `-${Math.min(headerBottom, window.innerHeight - 1)}px 0px 0px 0px` });
      stickyObserver.observe(mainButton);
      refreshSticky();
    };
    window.addEventListener('scroll', refreshSticky, { passive: true });
    window.addEventListener('resize', observeMainButton);
    syncSticky();
    observeMainButton();
  }

  const gallery = section.querySelector(`#Slider-Gallery-${section.dataset.section}`);
  const seedGallery = section.querySelector('[data-hg-seed-gallery]');
  if (seedGallery) {
    const viewport = seedGallery.querySelector('[data-hg-seed-viewport]');
    const thumbRail = seedGallery.querySelector('.hg-seed-gallery__thumbs');
    const slides = [...seedGallery.querySelectorAll('[data-hg-seed-slide]')];
    const controls = [...seedGallery.querySelectorAll('[data-hg-seed-index]')];
    const updateSeedGallery = () => {
      if (!viewport || !slides.length) return;
      const current = slides.reduce((best, slide, index) =>
        Math.abs(slide.offsetLeft - slides[0].offsetLeft - viewport.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - viewport.scrollLeft) ? index : best, 0);
      controls.forEach((control) => {
        const active = Number(control.dataset.hgSeedIndex) === current;
        if (control.hasAttribute('aria-pressed')) control.setAttribute('aria-pressed', String(active));
        if (control.hasAttribute('aria-current')) control.setAttribute('aria-current', String(active));
      });
      if (thumbRail?.classList.contains('hg-seed-gallery__thumbs--overflow')) {
        const activeThumb = thumbRail.querySelector(`[data-hg-seed-index="${current}"]`);
        if (activeThumb) {
          const top = activeThumb.offsetTop - thumbRail.offsetTop;
          if (top < thumbRail.scrollTop) thumbRail.scrollTo({ top, behavior: 'smooth' });
          else if (top + activeThumb.offsetHeight > thumbRail.scrollTop + thumbRail.clientHeight) {
            thumbRail.scrollTo({ top: top + activeThumb.offsetHeight - thumbRail.clientHeight, behavior: 'smooth' });
          }
        }
      }
    };
    controls.forEach((control) => control.addEventListener('click', () => {
      const slide = slides[Number(control.dataset.hgSeedIndex)];
      if (slide) viewport.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }));
    viewport?.addEventListener('scroll', updateSeedGallery, { passive: true });
    updateSeedGallery();
  }
  section.querySelectorAll('[data-hg-gallery-step]').forEach((button) => button.addEventListener('click', () => {
    const slides = [...gallery?.querySelectorAll('.product__media-item') || []];
    if (slides.length < 2) return;
    const current = slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left) < Math.abs(slides[best].getBoundingClientRect().left - gallery.getBoundingClientRect().left) ? index : best, 0);
    const next = (current + Number(button.dataset.hgGalleryStep) + slides.length) % slides.length;
    const dot = section.querySelector(`[data-hg-gallery-index="${next}"]`);
    if (matchMedia('(max-width: 749px)').matches && dot) dot.click();
    else {
      const thumb = section.querySelectorAll('.thumbnail-list__item button')[next];
      if (thumb) thumb.click();
      else slides[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }));

  const recommendation = document.querySelector('.hg-related-products[data-url]');
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-hg-related-step]');
    if (!control) return;
    const track = control.closest('.hg-related-products__carousel')?.querySelector('.hg-related-products__track');
    const card = track?.querySelector('li');
    if (track && card) track.scrollBy({ left: Number(control.dataset.hgRelatedStep) * (card.getBoundingClientRect().width + 16), behavior: 'smooth' });
  });
  if (recommendation && !recommendation.hasAttribute('data-hg-curated')) {
    const wrap = recommendation.closest('[data-hg-recommendations-wrap]');
    const url = recommendation.dataset.url;
    const load = async (intent) => {
      const response = await fetch(`${url.replace(/&intent=\w+/, '')}&intent=${intent}&product_id=${encodeURIComponent(recommendation.dataset.productId)}&section_id=${encodeURIComponent(recommendation.dataset.sectionId)}`, { credentials: 'same-origin' });
      if (!response.ok) return false;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const rendered = html.querySelector('.hg-related-products');
      if (!rendered?.querySelector('.grid__item')) return false;
      recommendation.innerHTML = rendered.innerHTML;
      return true;
    };
    wrap.hidden = true;
    (async () => {
      try { wrap.hidden = !(await load('complementary') || await load('related')); }
      catch (_) { wrap.hidden = true; }
    })();
  }
})();
